import React from 'react'

import * as styles from './sub-section.module.scss'

import HeadingLevel from '../../Shared/HeadingLevel/HeadingLevel'
import SectionAlternateGrid from '../SectionAlternateGrid/SectionAlternateGrid'

const SubSection = ({
    data
}) => {
    const {
        containerSize,
        sections,
        title,
        subText,
        headingLevel,
        boxType,
        subTextContainerSize,
        subTextClass,
        description
    } = data

    return (
        <div className={`container container-${containerSize} ${styles[`container${headingLevel}`]} ${styles.container} ${boxType && styles.box}`}>
            <div className={styles.headingDiv}>
                <HeadingLevel
                    title={title}
                    headingLevel={headingLevel}
                    extraClass={styles.headerTitle}
                />
                <div className={`container container-${subTextContainerSize} ${subTextClass ? styles[subTextClass] : ''}`}>
                    {
                        subText
                            ? <p>
                                {
                                    subText?.split('/n').map((phrase, index) => (
                                        <span style={{ display: 'block' }} key={index}>{phrase}</span>
                                    ))
                                }
                            </p>
                            : <p>{description?.description}</p>
                    }
                </div>
            </div>
            {
                sections?.map((section, index) => {
                    switch (section.__typename) {
                        case "ContentfulSectionAlternateGrid":
                            return (
                                <SectionAlternateGrid data={section} key={index} />
                            )
                    }
                })
            }
        </div>
    )
}

export default SubSection